import { render, staticRenderFns } from "./BlockLeaderBoardAffiliates.vue?vue&type=template&id=7d2a8bd0"
import script from "./BlockLeaderBoardAffiliates.vue?vue&type=script&lang=js"
export * from "./BlockLeaderBoardAffiliates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports